import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import Select from 'react-select';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class AdaniGasStationFilter extends Component {
    state = {
        gasStationLists:[],
        gasStationValue:null,

    };
    componentDidMount(){
        this._get_adani_gas_station_name();
    }

    resetGasStationFilter(){
        this.setState({
        gasStationValue: [],
        })
    }
     _get_adani_gas_station_name(){
        axios.get(config.get('API_URL')+'/filters/get-gas-station-name/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((name, index) => {
                    this.state.gasStationLists.push({value: name.gas_station_name, label: name.gas_station_name})
                });
            }
        });
     }
     changeGasStation(optionSelected){
        let value='';
        let gasStationArray = [];
        if(optionSelected.length < 1){
            value = null;
            gasStationArray='';
        }
        else{
            optionSelected.map((mids, i) => {
                gasStationArray.push(mids.value)
                var index = this.state.gasStationLists.findIndex(obj => obj.value==mids.value);
                this.state.gasStationLists.move(index,0).join(',');

            });
        }
        this.props.onSelectGasStation(optionSelected,gasStationArray);
        this.setState({
            gasStationValue:optionSelected,
        });
    }
    render() {

        return (
            <ReactMultiSelectCheckboxes name="email"
            isMulti
            value={this.state.gasStationValue}
            styles={reactSelectStyles} className="report-listbox"
            isClearable={false}
            onChange={this.changeGasStation.bind(this)}
            options={this.state.gasStationLists}
            placeholderButtonLabel="Select [Gas Station]"
        />
        );

    }
}
export default AdaniGasStationFilter;